class FlexaConverterProductState extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeProperties();
    this.setupEventListeners();
  }

  initializeProperties() {
    this.currentRole = this.dataset.role;
    this.domElements = {
      product: this.querySelector("[data-product-id]"),
      buttonText: this.querySelector("[data-btn-text]"),
      container: this.querySelector("[data-container]"),
      trigger: this.querySelector("gtc-trigger"),
      description: this.querySelector("[data-description]"),
    };
  }

  setupEventListeners() {
    document.addEventListener("collection-selected", () => this.resetState());
    document.addEventListener("color-selected", () => this.onColorSelected());
    document.addEventListener("product-selected", (event) => this.handleProductSelected(event.detail));
  }

  onColorSelected() {
    this.resetState();
    if (this.currentRole == 'current') {
      this.domElements.description.remove();
    }
  }

  resetState() {
    this.domElements.container.replaceChildren(...this.createEmptyStateElements());
    this.initializeProperties();

    if (this.domElements.buttonText) {
      this.updateButtonText(this.getString("button"));
    } else {
      this.domElements.trigger.hidden = true;
    }
  }

  createEmptyStateElements() {
    const html = this.generateEmptyStateHtml();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return Array.from(doc.body.children);
  }

  generateEmptyStateHtml() {
    return `
      <label class="flexa-converter__product flexa-converter__product--empty">
        <p class="flexa-converter__product__content__title">
          ${this.getString("notSelected")}
        </p>
        <p class="flexa-converter__product__content__description" data-description="${this.currentRole}">
          ${this.getString("selectFirst")}
        </p>
      </label>
    `;
  }

  handleProductSelected({ role, element }) {
    if (role == 'current' && this.currentRole == 'upgrade') {
      this.domElements.description.remove();
    }

    if (role !== this.currentRole) return;

    const clonedElement = this.markElementAsSelected(element.cloneNode(true));
    this.domElements.container.replaceChildren(clonedElement);

    if (this.domElements.buttonText) {
      this.updateButtonText(this.getString("buttonChange"));
    } else {
      this.domElements.trigger.hidden = false;
    }
  }

  markElementAsSelected(element) {
    element.classList.add("flexa-converter__product--selected");
    return element;
  }

  updateButtonText(text) {
    this.domElements.buttonText.innerText = text;
  }

  getString(key) {
    return window.theme.converterStrings[this.currentRole][key];
  }
}

customElements.define("flexa-converter-product-state", FlexaConverterProductState);